module.exports = __webpack_public_path__ + "img/success4.dbcfead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success_img/success4.jpg
// module id = duBh
// module chunks = 0